<template>
  <div class="li-embed-wrap">
    <iframe
      v-if="embedSrc"
      :src="embedSrc"
      allowfullscreen
      frameborder="0"
      scrolling="no"
      title="LinkedIn post"
      style="width:100%; height: 100%; position:absolute; inset:0; border:0;"
    />
  </div>
</template>

<script>
export default {
  name: 'LinkedInPost',
  props: { 
    postUrl: { 
      type: String, 
      required: true 
    }, 
    compact: { 
      type: Boolean, 
      default: true 
    } 
  },
  computed: {
    embedSrc() {
      try {
        const u = new URL(this.postUrl);
        if (!/linkedin\.com$/.test(u.hostname)) return null;

        // Try common patterns to extract the numeric activity ID
        // ex: /posts/author_title-activity-1234567890123456789-... or /feed/update/urn:li:activity:123...
        const path = decodeURIComponent(u.pathname);
        let id = null;

        const m1 = path.match(/activity-(\d+)/);                 // posts/...-activity-123...
        const m2 = path.match(/\/activity\/(\d+)/);               // /feed/update/activity/123...
        const m3 = path.match(/urn:li:activity:(\d+)/);           // already a URN in URL
        if (m1) id = m1[1];
        else if (m2) id = m2[1];
        else if (m3) id = m3[1];

        if (!id) return null;
        const base = `https://www.linkedin.com/embed/feed/update/urn:li:activity:${id}`;
        return this.compact ? `${base}?compact=true` : base;      // compact trims chrome/height
      } catch { return null; }
    }
  }
}
</script>

<style>
.li-embed-wrap {
  position: relative;
  width: 100%;
  min-height: 520px; /* adjust as needed */
  border-radius: 12px;
  overflow: hidden;
}
</style>